import appService from '../js/appservice/index'
import { getErrorMessage } from '../js/helpers/storehelper'

const state = {
  folderStructure: []
}

const getters = {
  folderStructure: state => state.folderStructure
}

const actions = {
  getFolderStructure(context) {
    return new Promise((resolve, reject) => {
      appService.imagebank
        .getFolderStructure()
        .then(data => {
          context.commit('folderStructure', data)
          resolve()
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  uploadImage(context, fData) {
    return new Promise((resolve, reject) => {
      appService.imagebank
        .uploadImage(fData)
        .then(data => {
          resolve(data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  },
  addFolder(context, folder) {
    return new Promise((resolve, reject) => {
      appService.imagebank
        .addFolder(folder)
        .then(data => {
          resolve(data)
        })
        .catch(error => {
          reject(getErrorMessage(error))
        })
    })
  }
}

const mutations = {
  folderStructure(state, data) {
    state.folderStructure = data
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
